import type { DeliverySlot } from '@@partner:types:app'
import { SlotsFiltersType } from '@components/shop/slot/SlotsFilter'

import { zfill } from './util'
import { groupBy } from 'rambda'
import { makeBetweenFilter } from './crud/filters'

export const makeSlotLabel = (slot: DeliverySlot) => {
  const from = new Date(Number(slot.period.from))
  const to = new Date(Number(slot.period.to))

  return `${timeStringFromDate(from)}-${timeStringFromDate(to)}`
}

export const timeStringFromDate = (dateObj: Date) => {
  return `${zfill(dateObj.getHours())}:${zfill(dateObj.getMinutes())}`
}

export const makeMonthName = (slot: DeliverySlot) => {
  const monthsName = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря'
  ]

  const monthNum = new Date(Number(slot.period.from)).getMonth()
  return monthsName[monthNum]
}

export const makeWeekDay = (slot: DeliverySlot) => {
  const weekDay = [
    'воскресенье',
    'понедельник',
    'вторник',
    'среда',
    'четверг',
    'пятница',
    'суббота'
  ]

  const weekDayNum = new Date(Number(slot.period.from)).getDay()
  return weekDay[weekDayNum]
}

export const makeRelativeDayLabel = (slot: DeliverySlot) => {
  const day = new Date(Number(slot.period.from)).getDate()
  const today = new Date().getDate()

  switch (day) {
  case today:
    return 'Сегодня'
  case today + 1:
    return 'Завтра'
  default:
    return day + ' ' + makeMonthName(slot)
  }
}

// TODO: add typing
export const makeRelativeDay = (date: any) => {
  const day = new Date(parseInt(date)).getDate()
  const month = new Date(parseInt(date)).getMonth()
  const today = new Date().getDate()

  switch (day) {
  case today:
    return 'Сегодня'
  case today + 1:
    return 'Завтра'
  default:
    return day + '.' + month
  }
}

// [*] -> { x: [*], ... }
export const groupSlotsByDay = groupBy((slot: DeliverySlot) => {
  const date = new Date(Number(slot.period.from))
  if (date.getDate() === new Date().getDate()) {
    const Slotday =
      'Сегодня, ' +
      date.getDate() +
      ' ' +
      makeMonthName(slot) +
      ', ' +
      makeWeekDay(slot)
    return Slotday
  }
  else if (date.getDate() === new Date().getDate() + 1) {
    const Slotday =
      'Завтра, ' +
      date.getDate() +
      ' ' +
      makeMonthName(slot) +
      ', ' +
      makeWeekDay(slot)
    return Slotday
  }
  else {
    const Slotday =
      date.getDate() + ' ' + makeMonthName(slot) + ', ' + makeWeekDay(slot)
    return Slotday
  }
})

export const makeDefaultFilter = (field: string) => ({
  fields: [ field ],
  op: 'unwrap'
})

export const prepareSlotsFilter = (filters: SlotsFiltersType) => {
  const periodFilter = makeBetweenFilter('ts_start', filters.ts_start)

  return {
    and: [
      periodFilter
    ]
  }
}